<template>
    <div>

      <b-card no-body >

        <b-card-body>
          <div class="d-flex justify-content-between  flex-wrap">

            <b-col lg="4">
              <b-form-group
                  label-for="filterInput"
                  class="mb-0"
              >
                <b-button
                    variant="gradient-primary"
                    size="sm"
                    class="mr-1"
                    @click="traerAreas"
                    title="Recargar"
                >
                  <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                </b-button>
                <!--
                <b-button
                    variant="gradient-primary"
                    size="sm"
                    class="mr-1"
                    v-b-modal.modal-prevent-closing
                >
                  <font-awesome-icon icon="fa-solid fa-plus"/>
                </b-button>
                -->
                <b-button
                    variant="gradient-primary"
                    size="sm"
                    v-b-modal.modal-importar
                    class="mr-1"
                    title="Descargar Excel"
                    @click="descargarFile"
                >
                  <span>
                    <font-awesome-icon icon="fa-solid fa-file-excel"/>
                  </span>
                </b-button>
                <b-button
                    @click="registrarCambios()"
                    variant="gradient-primary"
                    size="sm"
                    class="mr-1"
                    title="Guardar cambios"
                    id="exp_ope"
                    :disabled="loadingSave"
                >
                  <span v-if="loadingSave"><b-spinner style="width: 16px; height: 16px;" /></span>
                  <feather-icon v-else icon="SaveIcon" />
                </b-button>
                <b-button
                    variant="gradient-primary"
                    size="sm"
                    class="mr-1"
                    @click="rellenarVacios"
                    title="Actualizar Registros"
                    :disabled="loading"
                >
                  <font-awesome-icon icon="fa-solid fa-person" :spin="loading"/>
                </b-button>
                <label class="text-bold font-weight-bold font-medium-1 ml-3">Mostrando {{ items.length }} registros</label>
              </b-form-group>
            </b-col>

            <!-- <b-form-group
              label-for="fecha_inicio"
              label="Fecha de Inicio"
            >
              <b-form-datepicker
                  id="fecha_inicio"
                  v-model="fecha_inicio"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  :hide-header=true
                  start-weekday="1"
                  v-bind="labels || {}"
                  today-button
                  reset-button
                  size="sm"
                  close-button
                  name="fecha_inicio"
                  placeholder="Fecha de Inicio"
                  @input="obtenerHistorialCosechadores"
              />
            </b-form-group>

            <b-form-group
              label-for="fecha_fin"
              label="Fecha Fin"
            >
              <b-form-datepicker
                id="fecha_fin"
                v-model="fecha_fin"
                :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                :hide-header=true
                start-weekday="1"
                v-bind="labels || {}"
                today-button
                reset-button
                size="sm"
                close-button
                name="fecha_fin"
                placeholder="Fecha Fin"
                @input="obtenerHistorialCosechadores"
              />
            </b-form-group> -->
            <b-col lg="8" class="d-flex" style="justify-content: end;">
              <!-- Fecha de Inicio -->
              <b-form-group
                label-for="fecha_inicio"
                style="width: 200px; margin-left: 10px;"
                >
                <!-- label="Fecha de Inicio" -->
                <b-form-datepicker
                    id="fecha_inicio"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    :hide-header=true
                    start-weekday="1"
                    today-button
                    reset-button
                    size="sm"
                    close-button
                    name="fecha_inicio"
                    placeholder="Fecha de Inicio"
                    v-model="fecha_inicio"
                    @input="traerAreas"
                    style="z-index:170"
                />
              </b-form-group>
              <!-- Fecha Fin -->
              <b-form-group
                label-for="fecha_fin"
                style="width: 200px;margin-left: 10px;"
                >
                <!-- label="Fecha Fin" -->
                <b-form-datepicker
                  id="fecha_fin"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  :hide-header=true
                  start-weekday="1"
                  today-button
                  reset-button
                  size="sm"
                  close-button
                  name="fecha_fin"
                  placeholder="Fecha Fin"
                  v-model="fecha_fin"
                  @input="traerAreas"
                  style="z-index:170"
                />
              </b-form-group>
              <!------------- Filtros ----------->
              <b-form-group
                  label-for="filterInput"
                  style="width: 200px;margin-left: 10px;"
              >
                <!-- Buscar -->
                <b-input-group size="sm">
                  <b-form-input
                      id="filterInput"
                      v-model="dato_buscado"
                      type="search"
                      placeholder="Buscar"
                      @input="filtrarBusquedas"
                  />
                  <b-input-group-append>
                    <b-button
                        @click="limpiarBusqueda"
                    >
                      Borrar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

          </div>
        </b-card-body>

        <!-- <b-table
            hover
            responsive
            small
            sticky-header="58vh"
            class="position-relative tablita"
            :items="items"
            :fields="fields"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="loading"
            show-empty
            empty-text="No se encontraron datos en esta tabla."
            emptyFilteredText="No se encontraron datos con los parámetros ingresados."
        >
          <template #table-busy>
            <div class="text-center text-dark my-1">
              <b-spinner class="align-middle"></b-spinner> &emsp;
              <strong>Obteniendo datos...</strong>
            </div>
          </template>
          <template #cell(estado)="data">
            <b-badge :variant="status[1][parseInt(data.value)]">
              {{ status[0][parseInt(data.value)] }}
            </b-badge>
          </template>

          <template #cell(firma)="data">
            <div class="text-nowrap">
              <feather-icon
                  :id="`btn_${data.item.id}_ver`"
                  icon="ImageIcon"
                  size="16"
                  class="text-info mx-1"
                  @click="verFirma(data.item.firma)"
              />
            </div>
          </template>


          <template #cell(acciones)="data">
            <div class="text-nowrap" >

              <feather-icon
                  :id="`btn_${data.item.id}_editar`"
                  icon="EditIcon"
                  size="16"
                  class="mx-1 text-info"
                  @click="mostrarModalEditar(data.item)"
              />

            </div>
          </template>
          <template #cell(con_evaluador)="data">
            <span class="text-nowrap">{{data.value.nombres}} {{data.value.apellidos}}</span>
          </template>
          <template #cell(created)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value.split('/')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
          </template>
          <template #cell(modified)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value.split('/')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
          </template>
        </b-table> -->

        <hot-table
            ref="hotTableComponent"
            :data="items"
            licenseKey='non-commercial-and-evaluation'
        />

      </b-card>
      <b-modal
          id="modalRegistroFirma"
          v-model="estadoModalFirma"
          :ok-title="infoModal.boton"
          ok-only
          ok-title="Aceptar"
          :title="`Firma`"
          scrollable
      >
        <b-row>
          <b-col
              lg="12"
          >
            <b-card
                :img-src="fotosFirma"
                overlay
                text-variant="white"
                img-alt="card img"
                body-class=""
            >
            </b-card>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal
          id="modal-editar"
          ref="modal-editar"
          v-model="estadoModalEditar"
          title="Editar Estado"
          ok-title="Editar"
          cancel-title="Cancelar"
          cancel-variant="outline-secondary"
          size="lg"
          centered
          :ok-disabled="loadingEditar"
          :cancel-disabled="loadingEditar"
          no-close-on-esc
          no-close-on-backdrop
          @show=""
          @hidden="resetModal"
          @ok="validacionEditar"
      >
        <div v-if="loadingEditar"  align="center">
          <p>Editando ... </p>
          <b-spinner label="Editando..." variant="primary"/>
        </div>
        <validation-observer v-else ref="formularioEditar" #default="{invalid}">
          <b-form autocomplete="off" @submit.prevent="editarEstado">
            <b-row>
              <b-col lg="4">
                <b-form-group
                    label="DNI"
                    label-for="dni_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="DNI"
                      vid="dni_e"
                      rules="required"
                  >
                    <b-form-input
                        id="dni_e"
                        v-model="dni"
                        :state="errors.length > 0 ? false:null"
                        name="dni_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="8">
                <b-form-group
                    label="Nombres"
                    label-for="nombres_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Nombres"
                      vid="nombres_e"
                      rules="required"
                  >
                    <b-form-input
                        id="nombres_e"
                        v-model="nombres"
                        :state="errors.length > 0 ? false:null"
                        name="nombres_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="Cargo"
                    label-for="cargo_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Cargo"
                      vid="cargo_e"
                      rules="required"
                  >
                    <b-form-input
                        id="cargo_e"
                        v-model="cargo"
                        :state="errors.length > 0 ? false:null"
                        name="cargo_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                    label="Packing"
                    label-for="area_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Packing"
                      vid="area_e"
                      rules="required"
                  >
                    <b-form-input
                        id="area_e"
                        v-model="area"
                        :state="errors.length > 0 ? false:null"
                        name="area_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                    label="Labor"
                    label-for="labor_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Labor"
                      vid="labor_e"
                      rules="required"
                  >
                    <b-form-input
                        id="labor_e"
                        v-model="labor"
                        :state="errors.length > 0 ? false:null"
                        name="labor_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="Código"
                    label-for="codigo_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Código"
                      vid="codigo_e"
                  >
                    <b-form-input
                        id="codigo_e"
                        v-model="codigo"
                        :state="errors.length > 0 ? false:null"
                        name="codigo_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                    label="Implemento"
                    label-for="implemento_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Implemento"
                      vid="implemento_e"
                      rules="required"
                  >
                    <b-form-input
                        id="implemento_e"
                        v-model="implemento"
                        :state="errors.length > 0 ? false:null"
                        name="implemento_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                    label="Color"
                    label-for="color_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Color"
                      vid="color_e"
                      rules="required"
                  >
                    <b-form-input
                        id="color_e"
                        v-model="color"
                        :state="errors.length > 0 ? false:null"
                        name="color_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="4">
                <b-form-group
                    label="Talla"
                    label-for="talla_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Talla"
                      vid="talla_e"
                      rules="required"
                  >
                    <b-form-input
                        id="talla_e"
                        v-model="talla"
                        :state="errors.length > 0 ? false:null"
                        name="talla_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                    label="Cantidad"
                    label-for="cantidad_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Cantidad"
                      vid="cantidad_e"
                      rules="required"
                  >
                    <b-form-input
                        id="cantidad_e"
                        v-model="cantidad"
                        :state="errors.length > 0 ? false:null"
                        name="cantidad_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                    label="Observacion"
                    label-for="observacion_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Observacion"
                      vid="observacion_e"
                  >
                    <b-form-input
                        id="observacion_e"
                        v-model="observacion"
                        :state="errors.length > 0 ? false:null"
                        name="observacion_e"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="12">
                <b-form-group
                    label="Estado"
                    label-for="estado_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Estado"
                      vid="estado_e"
                      rules="required"
                  >
                    <v-select
                        id="estado_e"
                        v-model="estado"
                        :options="estados"
                        :reduce="estados => estados.value"
                        label="text"
                        key="value"
                        placeholder="Seleccionar estado..."
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>
    </div>
  </template>

  <script>

  import axiosIns from '../../libs/axios'
  import vSelect from 'vue-select'
  import { HotTable } from '@handsontable/vue'
  import { registerAllModules } from 'handsontable/registry'
  import { esMX, registerLanguageDictionary } from 'handsontable/i18n'


  import { BBadge, BButton, BCard, BCardBody, BForm, BFormGroup, BFormInput, BFormSelect, BModal, BPagination, BSpinner, BTable, BRow, BCol, BDropdownDivider, BTooltip, BInputGroupAppend, BInputGroup, BFormDatepicker, BFormTimepicker} from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
  import { required } from '@validations'
  import ToastificationContent from '@core/components/toastification/ToastificationContent'

  registerAllModules();
  registerLanguageDictionary(esMX);

  let digitos_fecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
  let fecha_hoy=new Date()
  //Formateo fecha_hoy
  let fecha_actual = fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
  fecha_actual=fecha_actual[2]+'-'+fecha_actual[1]+'-'+fecha_actual[0]

  export default {
    components: {
      BCard,
      BCardBody,
      BTable,
      BSpinner,
      BBadge,
      BFormGroup,
      BFormSelect,
      BPagination,
      BButton,
      BFormInput,
      BModal,
      BForm,
      BCol,
      BRow,
      BDropdownDivider,
      BTooltip,
      BInputGroupAppend,
      BInputGroup,
      BFormDatepicker,
      BFormTimepicker,
      vSelect,

      ValidationProvider,
      ValidationObserver,

      HotTable,
    },
    directives: {
    },
    data: () => ({
      loading: false,
      loading2: false,
      dato_buscado: '',
      foto:'',
      items: [],
      items_filtrado : [],
      fecha_inicio:'2023-01-01',
      fecha_fin: fecha_actual,
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 0,
      currentPage: 1,
      filter: null,
      filterOn: [],
      fields: [
        {
          key: 'acciones',
          label: '#',
          stickyColumn: true
        },
          /*
        {
          key: 'id',
          label: 'N°',
        },
        */
        {
          key: 'estado',
          label: 'estado',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'fecha_hora',
          label: 'Fecha y Hora de Entrega',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'dni',
          label: 'DNI',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'nombres',
          label: 'Nombres',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'cargo',
          label: 'Cargo',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'packing',
          label: 'Packing',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'area',
          label: 'Área',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'labor',
          label: 'Labor',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'codigo',
          label: 'Código',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'implemento',
          label: 'Implemento',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'color',
          label: 'Color',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'talla',
          label: 'talla',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'cantidad',
          label: 'cantidad',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'fecha_hora_cierre',
          label: 'Fecha y Hora de Cierre',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'observacion',
          label: 'Observación',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'firma',
          label: 'Firma',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'con_evaluador',
          label: 'Usuario Registro',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'created',
          label: 'Fecha Registro',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'modified',
          label: 'Fecha Edición',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
        {
          key: 'origen',
          label: 'Web/App',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
        },
      ],
      status: [
        {
          1: 'Pendiente',
          4: 'Devolución',
          7: 'Descuento',
        },
        {
          1: 'light-warning',
          4: 'light-success',
          7: 'light-danger',
        }
      ],


      fotosFirma: "",
      estadoModalFirma:false,
      infoModal: {
        title: '',
        boton: '',
      },

      loadingEditar: false,
      estadoModalEditar: false,

      id_editar: 0,
      id_evaluador: 0,
      dni: null,
      nombres: null,
      cargo: null,
      packing: null,
      area: null,
      labor: null,
      codigo: null,
      implemento: null,
      color: null,
      talla: null,
      cantidad: null,
      observacion: null,
      estado: null,

      estados: [
        {value: '1', text: "Pendiente"},
        {value: '4', text: "Devolución"},
        {value: '7', text: "Descuento"},
      ],

      // validation rules
      required,

      columnWidths: [
            null, // ESTADO
            null, // FECHA Y HORA DE ENTREGA
            null, // DNI
            260, // NOMBRES
            null, // CARGO
            null, // PACKING
            null, // AREA
            null, // LABOR
            null, // CODIGO
            null, // IMPLEMENTO
            null, // COLOR
            null, // TALLA
            null, // CANTIDAD
            null, // FECHA Y HORA DE CIERRE
            null, // OBSERVACION
            null, // FIRMA
            null, // USUARIO REGISTRO
            null, // FECHA REGISTRO
            null, // FECHA EDICION
            null, // WEB/APP
        ],

        busqueda: null,
        tabla: null,
        settings: null,

        arrayEditar: [],
        loadingSave: false,

    }),
    computed: {},
    mounted() {
        const yo = this
        yo.tabla = yo.$refs.hotTableComponent.hotInstance

        yo.settings = {
            width: '100%', //Ancho
            height: '55vh',
            rowHeaders: true, //Activar numeración de filas
            colHeaders: [
                'ID',
                'ESTADO',
                'FECHA Y HORA DE ENTREGA',
                'DNI',
                'NOMBRES',
                'CARGO',
                'PACKING',
                'AREA',
                'LABOR',
                'CODIGO',
                'IMPLEMENTO',
                'COLOR',
                'TALLA',
                'CANTIDAD',
                'FECHA Y HORA DE CIERRE',
                'OBSERVACION',
                'FIRMA',
                'USUARIO REGISTRO',
                'FECHA REGISTRO',
                'FECHA EDICION',
                'WEB/APP',
            ],
            columns: [
                {
                data: 'id',
                readOnly: true,
                editor : false
                },
                {
                    data: 'estado',
                    filter: false,

                    editor: 'select',
                    className: 'htCenter htMiddle',
                    allowInvalid: false,
                    selectOptions: [
                      'PENDIENTE',
                      'DEVOLUCION',
                      'DESCUENTO',
                    ],

                    renderer(instance, td, row, col, prop, value, cellProperties) {

                        let valor = ''

                        valor = value === null ? '' : value

                        if (valor == '1'){
                            valor = 'PENDIENTE'
                        }else if(valor == '4'){
                            valor = 'DEVOLUCION'
                        }else if(valor == '7'){
                            valor = 'DESCUENTO'
                        }

                        const spd = valor === 'PENDIENTE' ? 'light-warning'  : valor === 'DEVOLUCION' ? 'light-success' : valor === 'DESCUENTO' ? 'light-danger' : 'light-dark'

                        td.className = 'htCenter htMiddle'
                        td.innerHTML = '<b-badge class="badge badge-'+ spd +'">'+ valor +'</b-badge>'


                        return td
                    }
                },
                {
                    data: 'fecha_hora',
                    className: 'htCenter htMiddle',
                    readOnly: true,
                    editor : false
                },
                {
                    data: 'dni',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'nombres',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'cargo',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'packing',
                    type: 'text',
                    className: 'htMiddle',
                },
                {
                    data: 'area',
                    type: 'text',
                    className: 'htMiddle',
                },
                {
                    data: 'labor',
                    // dateFormat: 'YYYY-MM-DD',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'codigo',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'implemento',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'color',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'talla',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'cantidad',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                {
                    data: 'fecha_hora_cierre',
                    className: 'htMiddle',
                    readOnly: true,
                    editor : false
                },
                {
                    data: 'observacion',
                    type: 'text',
                    className: 'htCenter htMiddle',
                },
                // {
                //     data: 'firma',
                //     type: 'text',
                //     className: 'htCenter htMiddle',
                // },
                {
                  data: 'firma',
                  className: 'htCenter htMiddle',
                  renderer (instance, td, row, col, prop, value, cellProperties) {
                    const cellValue = instance.getDataAtRowProp(row, prop);
                    // Aquí, puedes agregar el código HTML necesario para mostrar el icono
                    td.style="text-align:center"
                        td.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" id="btn_1799_ver" class="text-info mx-1 feather feather-image"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg></span>'; // Ejemplo de un icono de información
                    td.addEventListener('click', function () {
                      // Aquí, puedes abrir el modal cuando se hace clic en el icono
                      // Puedes usar tu código de modal personalizado aquí
                      yo.verFirma(cellValue);
                    });
                  },

                },
                {
                    data: 'con_evaluador.nombres',
                    className: 'htCenter htMiddle',
                    readOnly: true,
                    editor : false
                },
                {
                    data: 'created',
                    className: 'htMiddle',
                    readOnly: true,
                    editor : false
                },
                {
                    data: 'modified',
                    className: 'htMiddle',
                    readOnly: true,
                    editor : false
                },
                {
                    data: 'origen',
                    className: 'htMiddle',
                    readOnly: true,
                    editor : false
                },
            ],

            language: esMX.languageCode, // Lenguaje español
            locale: "es-MX",
            dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
            filters: true,
            contextMenu: {
                items: {
                    // asistentes: {
                    //     name: "Ver Asistentes",
                    //     callback: function () {
                    //     const rowData = this.getDataAtRow(this.getSelected()[0][0])
                    //     if (rowData[0] != null && rowData[0]>0){
                    //         yo.mostrarAsistente(rowData[0], rowData[6])
                    //     }

                    //     },
                    // },
                    // pdf: {
                    //     name: "Descargar PDF",
                    //     callback: function () {
                    //     const rowData = this.getDataAtRow(this.getSelected()[0][0])
                    //     if (rowData[0] != null && rowData[0]>0 && rowData[2]==='REALIZADO'){
                    //         yo.exportarFilePDF(false, [rowData[0]])
                    //     }
                    //     },
                    // },
                    // link: {
                    //     name: "Ver Link",
                    //     callback: function () {
                    //     const rowData = this.getDataAtRow(this.getSelected()[0][0])

                    //     if (rowData[0] != null && rowData[0]>0 && rowData[2]==='EN PROCESO'){
                    //         yo.verLinks([rowData[0]], [rowData[6]], [rowData[24]])
                    //     }
                    //     },
                    // },
                    editar: {
                    name: "Editar",
                    callback: function () {
                      // if(yo.$can('edit', 'Temas Capacitaciones')) {
                      const fila = this.getSelected()[0][0]
                      for (let col = 0; col <= 31; col++) {
                        yo.tabla.setCellMeta(fila, col, 'readOnly', false);
                        const existingClasses = yo.tabla.getCellMeta(fila, col).className;
                        yo.tabla.setCellMeta(fila, col, 'className', existingClasses + ' tenue-amarillo');
                        // yo.tabla.setCellMeta(this.getSelected()[0][0], col, 'className', 'tenue-amarillo');
                      }
                      this.render();
                      // }
                    },
                  },
                },
            },
            columnSorting: true,
            manualColumnResize: true,
            readOnly: true,
            afterChange: this.afterChangeFuncion,
            fixedColumnsStart: 1,
            afterFilter: yo.afterFilterFuncion,
        }


        this.traerAreas();
        localize("es");
    },

    methods: {
      traerAreas(){
        const yo = this
        yo.loading = true

        yo.tabla.updateData([])

        yo.totalRows = 0

        const data = JSON.stringify(
            {
              "fecha_inicio": yo.fecha_inicio,
              "fecha_fin": yo.fecha_fin,
            }
        )

        const config = {
          method : 'post',
          url : '/elli/indumentaria/',
          data : data,
        };

        axiosIns(config)
            .then(function (response) {
                if(response.status === 200){
                    // console.log(response)
                    yo.items = response.data['response'];

                    yo.items_filtrado = yo.items

                    // yo.tabla.updateData(response.data)
                    yo.tabla.updateData(response.data['response'])
                    yo.settings.hiddenColumns = {
                        columns: [0]
                    }

                    yo.tabla.updateSettings(yo.settings)

                    yo.tabla.getPlugin('autoColumnSize').recalculateAllColumnsWidth()
                    yo.totalRows = yo.items.length
                    yo.loadingFiltro = true

                }

            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function (){
              yo.loading = false
            });
      },

      rellenarVacios(){
        const yo = this


        const config = {
          method: 'post',
          url: '/elli/indumentaria/exportar/rellenar/'
        }

        axiosIns(config)
            .then(function (response) {
              if(response.status === 200){

                //Sitodo salió bien, envío mensaje
                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Actualización exitosa',
                        icon: 'CheckIcon',
                        text: 'Se actualizaron los registros con éxito',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })

              }

            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la Actualización',
                  icon: 'XIcon',
                  text: 'Hubo un error en la actualización de registros, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function (){
              yo.traerAreas();
            })
      },

      filtrar(){
        const yo=this
        yo.items_filtrado=yo.items
        let dato_buscado=yo.dato_buscado

        const datosFiltrados = yo.items_filtrado.filter(diccionario => {
          return diccionario.codigo === dato_buscado;
        });

      },

      cPaginacion(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },


      descargarFile() {
        const yo = this
        // const spd = yo.items
        const spd = yo.items_filtrado
        const arrayFInal = []

        spd.forEach(function (value) {
          let estd = "";
          if(value.estado==="0" || value.estado==="1"){
            estd = "Pendiente"
          }else if(value.estado==="2" || value.estado==="3" || value.estado==="4"){
            estd = "Devolución"
          }else if(value.estado==="5" || value.estado==="6" || value.estado==="7"){
            estd = "Descuento"
          }

          arrayFInal.push(
              {
                "id": value.id,
                "fecha_hora": value.fecha_hora,
                "dni": value.dni,
                "nombres": value.nombres,
                "cargo": value.cargo,
                "area": value.area,
                "codigo": value.codigo,
                "implemento": value.implemento,
                "color": value.color,
                "talla": value.talla,
                "cantidad": value.cantidad,
                "fecha_hora_cierre": value.fecha_hora_cierre,
                "observacion": value.observacion,
                "estado": estd,
                "firma": value.firma,
                "con_evaluador": value.con_evaluador.nombres + " " +value.con_evaluador.apellidos,
                "origen": value.origen,
              }
          )
        })

        if (spd.length > 0){
          const data = JSON.stringify(
              {
                "datas":arrayFInal,
              }
          )

          const config = {
            method: 'post',
            url: 'elli/indumentaria/exportar/filter/',
            headers: {
              'Content-Type': 'application/json'
            },
            responseType: 'arraybuffer',
            data : data
          }

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200) {

                  const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                  const fileLink = document.createElement('a');
                  fileLink.href = fileURL;
                  fileLink.setAttribute('download', "Reporte de Entrega de Indumentaria.xlsx");
                  document.body.appendChild(fileLink);
                  fileLink.click();

                  yo.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Archivo creado',
                          icon: 'CheckIcon',
                          text: 'El archivo se creó satisfactoriamente.',
                          variant: 'success',
                        },
                      },
                      {
                        position: 'top-center',
                      })
                }
              })
              .catch(function (error) {
                console.log(error);
                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en la creación del archivo',
                    icon: 'XIcon',
                    text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.loading_exp = false
              });

        }else{
          yo.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: '¡Advertencia!',
                  icon: 'AlertTriangleIcon',
                  text: 'No se encuentran registros para exportar.',
                  variant: 'warning',
                },
              },
              {
                position: 'top-center',
              }
          )
        }
      },
      verFirma(fotos){
        this.estadoModalFirma = true;
        this.fotosFirma = fotos;
      },

      mostrarModalEditar(datos){
        const yo = this
        yo.estadoModalEditar = true
        yo.id_editar = datos.id
        yo.dni = datos.dni
        yo.nombres = datos.nombres
        yo.cargo = datos.cargo
        yo.packing = datos.packing
        yo.area = datos.area
        yo.labor = datos.labor
        yo.codigo = datos.codigo
        yo.implemento = datos.implemento
        yo.color = datos.color
        yo.talla = datos.talla
        yo.cantidad = datos.cantidad
        yo.observacion = datos.observacion
        yo.estado = datos.estado
        yo.id_evaluador = datos.con_evaluador.id
      },

      resetModal() {
        this.id_editar = null
        this.dni = null
        this.nombres = null
        this.cargo = null
        this.packing = null
        this.area = null
        this.labor = null
        this.codigo = null
        this.implemento = null
        this.color = null
        this.talla = null
        this.cantidad = null
        this.observacion = null
        this.estado = null
      },

      validacionEditar(bvModalEvt){
        bvModalEvt.preventDefault()
        this.editarEstado()
      },

      editarEstado(){
        const yo = this
        this.$refs.formularioEditar.validate().then(success => {
          if (success) {
            yo.loadingEditar = true
            const data = JSON.stringify(
                {
                  'dni': yo.dni,
                  'nombres': yo.nombres,
                  'cargo': yo.cargo,
                  'packing': yo.packing,
                  'area': yo.area,
                  'labor': yo.labor,
                  'codigo': yo.codigo,
                  'implemento': yo.implemento,
                  'color': yo.color,
                  'talla': yo.talla,
                  'cantidad': yo.cantidad,
                  'observacion': yo.observacion,
                  'estado': yo.estado,
                  'con_evaluador': yo.id_evaluador,
                  'origen': 'WEB'
                }
            )

            const config = {
              method: 'put',
              url: 'elli/indumentaria/editar/'+yo.id_editar,
              headers: {
                'Content-Type': 'application/json'
              },
              data: data
            }

            axiosIns(config)
                .then(function (response) {
                  if (response.status === 200){
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente.", 'success', 5000)
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en la edición', 'BellIcon', error.toString(), 'danger', 5000)
                })
                .finally(function (){
                  yo.traerAreas()
                  yo.$nextTick(() => {
                    yo.$refs['modal-editar'].toggle('#toggle-btn')
                  })
                  yo.loadingEditar = false
                })

          }
        })
      },

      mostrarNotificacion(titulo, icono, texto, variante, tiempo){
        this.$toast({
              component: ToastificationContent,
              props:{
                title: titulo,
                icon: icono,
                text: texto,
                variant: variante
              }
            },
            {
              timeout: tiempo,
              position: 'top-center',
            })
      },

      afterFilterFuncion (conditionsStack) {
        const yo = this
        yo.totalRows = yo.tabla.getData().length
        yo.tabla.getPlugin('autoColumnSize').recalculateAllColumnsWidth()
      },

      afterChangeFuncion (changes, source) {
        const yo = this

        if (source === 'CopyPaste.paste' && changes.length >= 24) {
          const addedRows = changes.reduce((rows, change) => {
            const row = change[0];
            if (!rows.includes(row)) {
              rows.push(row);
            }
            return rows;
          }, []);

          // console.log(addedRows)
          addedRows.forEach(row => {
            yo.tabla.setDataAtCell(row, 0, 'DUPLICADO');
            yo.tabla.setDataAtCell(row, 25, 0);
          });
        }

        if (source === 'edit') {
          const [fila, columna, antes, despues] = changes[0]
          if(antes !== despues){
            const rowData = yo.tabla.getDataAtRow(fila)
            // const existingClasses = yo.tabla.getCellMeta(fila, yo.columnas[columna]).className;
            // yo.tabla.setCellMeta(fila, yo.columnas[columna], 'className', existingClasses + ' tenue-amarillo');
            yo.arrayEditar.push({
              id: rowData[0],
              columna: columna,
              cambio: despues,
            })
          }
        }

        yo.tabla.render();
      },

      registrarCambios(){
        const yo = this

        if (yo.arrayEditar.length>0){
          yo.loadingSave = true

          const data = JSON.stringify({
            "editar": yo.arrayEditar
          })

          const config = {
            method: 'post',
            url: 'elli/indumentaria/crear_editar/',
            headers: {
              'Content-Type': 'application/json'
            },
            data : data
          }

          axiosIns(config)
              .then(function (response) {
                if(response.status === 200){

                  yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Registros guardados',
                      icon: 'CheckIcon',
                      text: 'El envío de los registros se realizó satisfactoriamente.',
                      variant: 'success',
                    },
                  })

                  yo.arrayEditar = []

                }
              })
              .catch(function (error) {
                console.log(error);

                yo.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error en el registro',
                    icon: 'XIcon',
                    text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                    variant: 'danger',
                  },
                })
              })
              .finally(function () {
                yo.loadingSave = false
                yo.traerAreas()
              })

        }
        else{
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: '¡Advertencia!',
              icon: 'CheckIcon',
              text: 'No se encontraron cambios por guardar.',
              variant: 'warning',
            },
          })
        }
      },

      filtrarBusquedas(){
        const yo = this

        if (this.dato_buscado === null || this.dato_buscado === '') {
          // Si la consulta está vacía, muestra todos los datos

          this.items_filtrado = this.items
          yo.tabla.updateData(yo.items_filtrado)
          return;
        }else if (this.dato_buscado.trim() === '') {
          // Si la consulta está vacía, muestra todos los datos

          this.items_filtrado = this.items
          yo.tabla.updateData(yo.items_filtrado)
          return;
        }else{
          const lowercaseQuery = this.dato_buscado.toLowerCase();
          this.items_filtrado = this.items.filter(row => {
            return Object.values(row).some(value =>
              String(value).toLowerCase().includes(lowercaseQuery)
            );
          });

        }
        yo.tabla.updateData(yo.items_filtrado)



      },

      limpiarBusqueda(){
        this.dato_buscado=''
        this.filtrarBusquedas();

      }

    },

  }
  </script>
  <style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .alinear-una-sola-linea{
    white-space: nowrap!important;
  }

  .tablita{
    min-height: 58vh!important;
  }

  .tablita::-webkit-scrollbar {
    width: 1.35vh;
    height: 1.35vh;
  }
  .tablita::-webkit-scrollbar-track {
    background-color: rgba(171, 171, 171, 0.35);
    border-radius: 6px;
    position: absolute;
  }
  .tablita::-webkit-scrollbar-thumb {
    background-image: linear-gradient(47deg, #82868b, #9ca0a4);
    border-radius: 6px;
    position: absolute;
  }

  .tenue-amarillo{
    background-color: rgba(204, 190, 41, 0.4)!important;
    font-weight: 500!important;
    font-size: 12px!important;
  }

  .tenue-rojo{
    background-color: rgba(204, 114, 41, 0.4) !important;
    font-weight: 500!important;
  }

  </style>
